(function() {
	angular.module('meanApp', [
		'ui.router',
		'ui.bootstrap',
		'ngAnimate',
		'ngImgCrop',
		'hmTouchEvents',
		'rzModule',
		'as.sortable',
		'ngFitText',
		'ngCookies'
	]);

	function config($stateProvider, $urlRouterProvider, $locationProvider) {
		$urlRouterProvider.rule(function($injector, $location) {
			var path = $location.path(),
				hasTrailingSlash = path[path.length - 1] === '/';

			if (hasTrailingSlash) {
				//if last charcter is a slash, return the same url without the slash
				var newPath = path.substr(0, path.length - 1);
				return newPath;
				//return path+'/';//always add a trailing slash
			}
		});

		$stateProvider
			.state('home', {
				url: '/',
				templateUrl: '/home/home.view.html',
				controller: 'homeCtrl',
				controllerAs: 'vm'
			})
			.state('recipeSearchResult', {
				url: '/recherche/resultats?tags',
				templateUrl: '/search/results.search.view.html',
				controller: 'searchCtrl',
				controllerAs: 'vm'
			})
			.state('recipeTextSearchResult', {
				url: '/recherche/resultats?search',
				templateUrl: '/search/results.search.view.html',
				controller: 'searchCtrl',
				controllerAs: 'vm'
			})
			.state('recipeSearchStep', {
				url: '/recherche/etape/:step',
				templateUrl: function($stateParams) {
					// Can not inject dependencies
					var templateURL = '/search/step.one.search.view.html';
					switch ($stateParams.step) {
						case '1':
							templateURL = '/search/step.one.search.view.html';
							break;
						case '2':
							templateURL = '/search/step.two.search.view.html';
							break;
						case '3':
							templateURL = '/search/step.three.search.view.html';
							break;
						case '4':
							templateURL = '/search/step.four.search.view.html';
							break;
					}
					return templateURL;
				},
				controller: 'searchCtrl',
				controllerAs: 'vm'
			})
			.state('recipecreation', {
				url: '/creer-ma-recette',
				templateUrl: '/recipe/step.one.creation.view.html',
				controller: 'recipeCtrl',
				controllerAs: 'vm'
			})
			.state('recipecreationstep', {
				url: '/recette/:id/edit/etape/:step',
				templateUrl: function($stateParams) {
					// Can not inject dependencies
					console.log('state params are', $stateParams);
					var templateURL = '/recipe/step.one.creation.view.html';
					switch ($stateParams.step) {
						case '1':
							templateURL = '/recipe/step.one.creation.view.html';
							break;
						case '2':
							templateURL = '/recipe/step.two.creation.view.html';
							break;
						case '3':
							templateURL = '/recipe/step.three.creation.view.html';
							break;
					}
					return templateURL;
				},
				controller: 'recipeCtrl',
				controllerAs: 'vm'
			})
			.state('recipe', {
				url: '/recette/:id',
				templateUrl: 'recipe/recipe.view.html',
				controller: 'recipeReadCtrl',
				controllerAs: 'vm'
			})
			.state('recipeInstructions', {
				url: '/recette/:id/preparation',
				templateUrl: 'recipe/recipe.instructions.view.html',
				controller: 'recipeReadCtrl',
				controllerAs: 'vm'
			})
			.state('recipeExport', {
				url: '/recette/:id/export',
				templateUrl: 'recipe/recipe.export.view.html',
				controller: 'recipeReadCtrl',
				controllerAs: 'vm'
			})
			.state('ingredientEdit', {
				url: '/ingredient/:slug/edit',
				templateUrl: '/ingredient/ingredient.edit.view.html',
				controller: 'ingredientsCtrl',
				controllerAs: 'vm'
			})
			.state('ingredient', {
				url: '/ingredient/:slug',
				templateUrl: '/ingredient/ingredient.view.html',
				controller: 'ingredientCtrl',
				controllerAs: 'vm'
			})
			.state('profile', {
				url: '/profil/:id',
				templateUrl: '/profile/profile.view.html',
				controller: 'profileCtrl',
				controllerAs: 'vm'
			})
			.state('profile.settings', {
				url: '/parametres',
				templateUrl: '/profile/settings.view.html'
			})
			.state('profile.info', {
				url: '/information',
				templateUrl: '/profile/info.view.html'
			})
			.state('profile.recipes', {
				controller: 'profileRecipesCtrl',
				controllerAs: 'subVm',
				url: '/recettes',
				templateUrl: '/profile/recipes.view.html'
			})
			.state('profile.likes', {
				controller: 'profileRecipesCtrl',
				controllerAs: 'subVm',
				url: '/recettes/aimees',
				templateUrl: '/profile/recipes.view.html'
			})
			.state('profile.bookmarks', {
				controller: 'profileRecipesCtrl',
				controllerAs: 'subVm',
				url: '/recettes/sauvegardees',
				templateUrl: '/profile/recipes.view.html'
			})
			.state('admin', {
				url: '/admin',
				templateUrl: '/admin/admin.view.html',
				//controller: 'adminCtrl',
				controllerAs: 'vm'
			})
			.state('admin.recipes', {
				url: '/recettes',
				templateUrl: '/admin/recipes.view.html',
				controller: 'recipesAdminCtrl',
				controllerAs: 'vm'
			})
			.state('admin.users', {
				url: '/utilisateurs',
				templateUrl: '/admin/users.view.html',
				controller: 'usersCtrl',
				controllerAs: 'vm'
			})
			.state('admin.ingredients', {
				url: '/ingredients',
				templateUrl: '/admin/ingredients.view.html',
				controller: 'ingredientsCtrl',
				controllerAs: 'vm'
			})
			.state('admin.measures', {
				url: '/mesures',
				templateUrl: '/admin/measures.view.html',
				controller: 'measuresCtrl',
				controllerAs: 'vm'
			})
			.state('admin.departments', {
				url: '/rayons',
				templateUrl: '/admin/departments.view.html',
				controller: 'departmentsCtrl',
				controllerAs: 'vm'
			})
			.state('admin.allergens', {
				url: '/allergenes',
				templateUrl: '/admin/allergens.view.html',
				controller: 'allergensCtrl',
				controllerAs: 'vm'
			})
			.state('admin.features', {
				url: '/proprietes',
				templateUrl: '/admin/features.view.html',
				controller: 'featuresCtrl',
				controllerAs: 'vm'
			})
			.state('recipesDiscovery', {
				url: '/recettes/tag/:tag/page/:page',
				templateUrl: '/discovery/recipe.discovery.view.html',
				controller: 'recipesDiscoveryCtrl',
				controllerAs: 'vm'
			})
			.state('ingredientWidget', {
				url: '/widget/ingredient/:slug',
				templateUrl: '/widgetDemo/ingredient.widget.view.html',
				controller: 'ingredientCtrl',
				controllerAs: 'vm'
			})
			.state('recipeWidget', {
				url: '/widget/recette/:slug',
				templateUrl: '/widgetDemo/recipe.widget.view.html',
				controller: 'recipeReadCtrl',
				controllerAs: 'vm'
			})
			.state('recipeWidgetNone', {
				url: '/widget/recette',
				templateUrl: '/widgetDemo/recipe.widget.view.html',
				controller: 'recipeReadCtrl',
				controllerAs: 'vm'
			})
			.state('contact', {
				url: '/contact',
				controller: 'contactCtrl',
				templateUrl: '/about/contact.view.html' //this is a static view so no controller here
			})
			.state('faq', {
				url: '/foire-aux-questions',
				controller: 'faqCtrl',
				controllerAs: 'vm',
				templateUrl: '/about/faq.view.html' //this is a static view so no controller here
			})
			.state('about', {
				url: '/about',
				controllerAs: 'vm',
				controller: 'aboutCtrl',
				templateUrl: '/about/about.view.html' //this is a static view so no controller here
			})
			.state('premium', {
				url:'/premium',
				controllerAs: 'vm',
				controller: 'premiumCtrl',
				templateUrl: '/premium/premium.view.html' //this is a static view so no controller here
			})
			.state('premiumPaymentSuccess', {
				url:'/premium/payment-success',
				controllerAs: 'vm',
				controller: 'premiumCtrl',
				templateUrl: '/premium/success.view.html' //this is a static view so no controller here
			})
		/**.caseInsensitiveMatch = true;**/
		// use the HTML5 History API this also remove the # tag that is appended to all the URLs. Ugly !
		$locationProvider.html5Mode({ enabled: true, requireBase: false });
		$urlRouterProvider.otherwise('/');
	}

	function run($rootScope, $location, context) {
		$rootScope.$on('$locationChangeSuccess', function(rootScope, currentPath, previousPath) {
			var currentState = context.getCurrentState();
			if (currentState) {
				context.setPreviousState(currentState);
			}
			if ($location.$$path) {
				context.setCurrentState($location.$$path);
			}
		});
	}

	angular
		.module('meanApp')
		.config([ '$stateProvider', '$urlRouterProvider', '$locationProvider', config ])
		.run([ '$rootScope', '$location', 'context', run ]);
})();
